import React, { useState, useLayoutEffect, useRef } from "react";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material"; import CommentCard from "src/pages/workspace-project/components/CommentCard";
import {
  CircularLoader,
  MuiDrawer,
  Iconify,
  MuiDialog,
  RichEditor,
  MentionMemoEditor,
} from "..";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";

const CommentsDrawer = ({
  open,
  onClose,
  selectedTask,
  disabled,
  comments,
  onCommentAction,
  loading,
  newComment,
  setNewComment,
  markCommentAsRead = () => { },
}) => {
  /* <<--------------------------------------------------------->> */
  const [editingComment, setEditingComment] = useState(false);
  const editorRef = useRef();
  const commentEditorRef = useRef();
  const scrollbarRef = useRef();
  const [processingEditComment, setProcessingEditComment] = useState(false);
  const [delCommentOpen, setDelCommentOpen] = useState(false);
  const [deletingTaskComment, setDeletingTaskComment] = useState(false);
  const [sendingComment, setSendingComment] = useState(false);
  const [selectedComment, setSelectedComment] = useState(undefined);
  const [editorKey, setEditorKey] = useState(0);
  const [expandedReplies, setExpandedReplies] = useState(new Set());

  const { enqueueSnackbar } = useSnackbar();
  /* <<--------------------------------------------------------->> */

  const onEditComment = (_comment) => {
    setEditorKey((prevKey) => prevKey + 1);
    setSelectedComment(_comment);
    setEditingComment(true);
  };
  const onDelComment = (_comment) => {
    setSelectedComment(_comment);
    openDelCommentDialog();
  };
  const handleCancelEditComment = async (e) => {
    setEditorKey((prevKey) => prevKey + 1);
    setEditingComment(false);
    setSelectedComment(undefined);
  };
  const closeDelCommentDialog = () => {
    setDelCommentOpen(false);
  };
  const openDelCommentDialog = () => {
    setDelCommentOpen(true);
  };
  const currentTask = () => {
    if (selectedTask) {
      return selectedTask;
    }
    return undefined;
  };
  const disableComment = () => {
    if (disabled === true) {
      return true;
    }
    if (!selectedTask) {
      return true;
    }

    return false;
  };
  const handleClose = () => {
    setNewComment({
      title: "",
      type: "0",
    });
    setEditingComment(false);
    setSelectedComment(undefined);
    onClose();
  };
  const handleDelTaskComment = async () => {
    setDeletingTaskComment(true);
    console.log(selectedComment, "to-del");
    if (!selectedComment) {
      console.log("no selectedComment");
      return;
    }
    const result = await onCommentAction("delete_comment", selectedComment);
    setDeletingTaskComment(false);
    closeDelCommentDialog();
    setSelectedComment(undefined);
    if (result.code === 200) {
      enqueueSnackbar("Comment deleted successfully", { variant: "success" });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleUpdateTaskComment = async () => {
    const val = commentEditorRef.current.getValue();
    const updatedComment = { ...selectedComment, comment_title: val };
    setProcessingEditComment(true);
    const result = await onCommentAction("edit_comment", updatedComment);
    console.log(result, "edit-com-res");
    setProcessingEditComment(false);
    setEditingComment(false);
    setSelectedComment(undefined);
    if (result.code === 200) {
      enqueueSnackbar("Comment updated successfully", { variant: "success" });
      setEditorKey((prevKey) => prevKey + 1);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };
  const handleSendComment = async () => {
    const val = commentEditorRef.current.getValue();
    const commentToSend = { ...newComment, title: val };
    setSendingComment(true);
    const result = await onCommentAction("add_comment", commentToSend);
    console.log(result, "add-com-res");
    setSendingComment(false);
    if (result.code === 200) {
      setEditorKey((prevKey) => prevKey + 1);
      setNewComment({
        title: "",
        type: "0",
      });
      handleScrollBarToBottom();
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };
  const handleScrollBarToBottom = () => {
    console.log(scrollbarRef, "scrl-ref");
    if (!scrollbarRef.current) return;
    scrollbarRef.current.scroll(0, 0);
  };
  /* <<--------------------------------------------------------->> */
  useEffect(() => {
    if (loading === false) {
      handleScrollBarToBottom();
    }
  }, [loading]);
  /* <<--------------------------------------------------------->> */

  return (
    <div>
      <MuiDrawer
        paperProps={{ width: { xs: 1, sm: 540, md: 450 } }}
        isOpen={open}
        onClose={handleClose}
        title="Task Comments"
        scrollbarRef={scrollbarRef}
        bottomComponent={
          <Stack sx={{ px: 2.5, pb: "5px" }}>
            <Stack
              sx={{ py: 1.5 }}
            // direction="row"
            // alignItems="center"
            // justifyContent="center"
            >
              {editingComment ? (
                <>
                  {/* <TextField
                  value={selectedComment?.comment_title}
                  onChange={({ target }) =>
                    setSelectedComment({
                      ...selectedComment,
                      comment_title: target.value,
                    })
                  }
                  fullWidth
                  autoFocus={true}
                  focused={true}
                  variant="outlined"
                  label="Comment"
                  multiline
                  rows={4}
                  disabled={processingEditComment || disableComment() === true}
                /> */}
                  {/* <RichEditor
                  key={editorKey}
                  editorRef={editorRef}
                  value={selectedComment?.comment_title}
                  setValue={(val) => {
                    setSelectedComment((prev) => {
                      return {
                        ...prev,
                        comment_title: val,
                      };
                    });
                  }}
                  disabled={processingEditComment || disableComment() === true}
                /> */}
                  <MentionMemoEditor
                    key={editorKey}
                    ref={commentEditorRef}
                    editorRef={editorRef}
                    value={selectedComment?.comment_title}
                    team={selectedTask?.team}
                    disabled={
                      processingEditComment || disableComment() === true
                    }
                    editorHeight={150}
                  />
                </>
              ) : (
                <>
                  {/* <TextField
                  autoFocus={true}
                  value={newComment.title}
                  onChange={({ target }) =>
                    setNewComment((prev) => {
                      return { ...prev, title: target.value };
                    })
                  }
                  fullWidth
                  variant="outlined"
                  label="Comment"
                  multiline
                  rows={4}
                  disabled={sendingComment || disableComment() === true}
                /> */}
                  {/* <RichEditor
                  key={editorKey}
                  editorRef={editorRef}
                  value={newComment?.title}
                  setValue={(val) =>
                    setNewComment((prev) => {
                      return { ...prev, title: val };
                    })
                  }
                  disabled={sendingComment || disableComment() === true}
                /> */}
                  <MentionMemoEditor
                    key={editorKey}
                    ref={commentEditorRef}
                    editorRef={editorRef}
                    value={newComment?.title}
                    team={selectedTask?.team}
                    disabled={sendingComment || disableComment() === true}
                    editorHeight={150}
                  />
                </>
              )}
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Stack direction="row" alignItems="center">
                <div className="centered-row">
                  {editingComment ? (
                    <FormControl>
                      <RadioGroup
                        row
                        disabled={
                          processingEditComment || disableComment() === true
                        }
                        aria-labelledby="gender-select-radio-buttons-label"
                        name="row-radio-buttons-group"
                        value={selectedComment?.comment_type}
                        onChange={({ target }) =>
                          setSelectedComment({
                            ...selectedComment,
                            comment_type: target.value,
                          })
                        }
                      >
                        <FormControlLabel
                          value="0"
                          control={<Radio />}
                          label="Public"
                          disabled={
                            processingEditComment || disableComment() === true
                          }
                        />
                        <FormControlLabel
                          disabled={
                            processingEditComment || disableComment() === true
                          }
                          value="1"
                          control={<Radio />}
                          label="Private"
                        />
                      </RadioGroup>
                    </FormControl>
                  ) : (
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="gender-select-radio-buttons-label"
                        name="row-radio-buttons-group"
                        value={newComment.type}
                        disabled={sendingComment || disableComment() === true}
                        onChange={({ target }) =>
                          setNewComment((prev) => {
                            return { ...prev, type: target.value };
                          })
                        }
                      >
                        <FormControlLabel
                          value="0"
                          control={<Radio />}
                          label="Public"
                          disabled={sendingComment || disableComment() === true}
                        />
                        <FormControlLabel
                          value="1"
                          control={<Radio />}
                          label="Private"
                          disabled={sendingComment || disableComment() === true}
                        />
                      </RadioGroup>
                    </FormControl>
                  )}
                </div>
              </Stack>
              {editingComment ? (
                <Stack
                  spacing={2}
                  direction="row"
                  alignItems="center"
                  justifyContent="center"
                >
                  <LoadingButton
                    loading={false}
                    size="small"
                    variant="contained"
                    onClick={() => handleCancelEditComment()}
                    startIcon={<Iconify icon="gridicons:cross" />}
                    color="error"
                    disabled={
                      processingEditComment || disableComment() === true
                    }
                  >
                    Cancel
                  </LoadingButton>
                  <LoadingButton
                    loading={processingEditComment}
                    size="small"
                    disabled={
                      processingEditComment || disableComment() === true
                    }
                    variant="contained"
                    onClick={() => handleUpdateTaskComment()}
                    startIcon={<Iconify icon="dashicons:saved" />}
                  >
                    Update
                  </LoadingButton>
                </Stack>
              ) : (
                <LoadingButton
                  loading={sendingComment}
                  size="small"
                  variant="contained"
                  disabled={
                    newComment.title.trim() === "" || disableComment() === true
                  }
                  onClick={handleSendComment}
                  startIcon={<Iconify icon="fluent:send-24-regular" />}
                >
                  Send
                </LoadingButton>
              )}
            </Stack>
          </Stack>
        }
        titleButton={
          selectedTask?.task_comment_unread_count > 0 && (
            <Tooltip title="Mark all comments as read">
              <Button
                variant="outlined"
                color="inherit"
                sx={{
                  textTransform: "none",
                  padding: "2px 8px",
                  minWidth: "auto",
                  borderRadius: "6px",
                  mr: 1.2,
                  mt: 0.5,
                  whiteSpace: "nowrap",
                }}
                onClick={() => markCommentAsRead("all")}
              >
                Mark all as read
              </Button>
            </Tooltip>
          )
        }
        headerComponent={
          currentTask() && (
            <Box sx={{ pt: "12px" }}>
              <Typography
                sx={{
                  px: 2.5,
                }}
                noWrap
                fontWeight="bold"
              >
                {currentTask().task_title}
              </Typography>
            </Box>
          )
        }
      >
        {currentTask() && (
          <>
            <Stack className="position-relative" spacing={1}>
              <AnimatePresence layout initial={false}>
                {comments
                  .filter((c) => !c.parent_comment_id)
                  .map((item) => {
                    const replies = comments.filter(
                      (c) => c.parent_comment_id === item._id
                    );
                    return (
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.2 }}
                        layout
                        key={item._id}
                      >
                        <Paper
                          elevation={0}
                          sx={{ overflow: "visible" }}
                        >
                          <CommentCard
                            onEdit={onEditComment}
                            onDel={onDelComment}
                            item={item}
                            currentUserRole={selectedTask.role}
                            markCommentAsRead={markCommentAsRead}
                            selectedTask={selectedTask}
                            hasReplies={replies.length > 0}
                          />
                          {replies.length > 0 && (
                            <Box
                              sx={{
                                backgroundColor: "#eff2ef",
                                borderRadius: "0 0 8px 8px",
                                border: "1px solid #dedede",
                                borderTop: "none",
                                px: 1.5,
                                pt: 1,
                                pb: 1.5,
                              }}
                            >
                              <Typography
                                variant="caption"
                                sx={{
                                  color: "text.secondary",
                                  fontWeight: 600,
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                  display: "block",
                                  mb: 1,
                                }}
                              >
                                {replies.length}{" "}
                                {replies.length === 1 ? "Reply" : "Replies"}
                              </Typography>
                              <Stack spacing={1}>
                                {/* comment replies card */}
                                {(expandedReplies.has(item._id)
                                  ? replies
                                  : replies.slice(0, 3)
                                ).map((reply) => (
                                  <CommentCard
                                    key={reply._id}
                                    item={reply}
                                    onEdit={onEditComment}
                                    onDel={onDelComment}
                                    currentUserRole={selectedTask.role}
                                    markCommentAsRead={markCommentAsRead}
                                    selectedTask={selectedTask}
                                    />
                                ))}
                              </Stack>
                              {replies.length > 3 && (
                                <Typography
                                  variant="caption"
                                  onClick={() =>
                                    setExpandedReplies((prev) => {
                                      const next = new Set(prev);
                                      if (next.has(item._id)) {
                                        next.delete(item._id);
                                      } else {
                                        next.add(item._id);
                                      }
                                      return next;
                                    })
                                  }
                                  sx={{
                                    mt: 1,
                                    display: "inline-block",
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                    color: "inherit",
                                  }}
                                >
                                  {expandedReplies.has(item._id)
                                    ? "Hide replies"
                                    : `View ${replies.length - 3} more ${replies.length - 3 === 1
                                      ? "reply"
                                      : "replies"
                                    }`}
                                </Typography>
                              )}
                            </Box>
                          )}
                        </Paper>
                      </motion.div>
                    );
                  })}
              </AnimatePresence>
              {loading && (
                <span className="comment-loader-wrap">
                  <span className="comment-loader">
                    <CircularLoader size="3rem" />
                  </span>
                </span>
              )}
              {!loading && comments.length === 0 && (
                <span className="comment-loader-wrap">
                  <span className="comment-loader">
                    <Typography
                      color={(theme) => theme.palette.text.disabled}
                      sx={{ mt: 30 }}
                      textAlign="center"
                    >
                      No comments added
                    </Typography>
                  </span>
                </span>
              )}
            </Stack>
          </>
        )}
      </MuiDrawer>
      {/* dialogs */}
      <MuiDialog
        open={delCommentOpen}
        onToggle={closeDelCommentDialog}
        onAgree={handleDelTaskComment}
        loading={deletingTaskComment}
        title="Delete Comment"
        message={`Are you sure you want to delete this comment?`}
      />
    </div>
  );
};

export default CommentsDrawer;
